import { VFC } from 'react'
import { Routes, Route } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'

import OutputTask from './OuputTask/OutputTask'

const TaskRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path='output/:workflowUuid/:taskUuid' element={<OutputTask />} />
      </Route>
    </Routes>
  )
}

export default TaskRoutes
